<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("screentype", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $tc("screentype", 2) }}
          {{ $tc("incinematic") }}
        </div>
      </div>
      <div>
        <router-link
          v-if="$can('create', 'Screen Type')"
          variant="default"
          class="btn-blue"
          to="add-screen-type"
          >{{ $tc("add") }}</router-link
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="dropdown-curve-container mr-2">
          <b-dropdown
            :disabled="isRoleID"
            :text="selectedStatus"
            variant="dropdown-curve"
            style="width: 200px"
          >
            <b-dropdown-item
              v-for="(dropdownItem, dropdownIndex) in status"
              :key="dropdownIndex"
              href="#"
              @click="onStatusChange(dropdownItem)"
            >
              {{ dropdownItem.label }}
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'screen_type_name'"
              @click="onSortValue('screen_type_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('screen_type_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('screen_type_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("screentype") }}
          </th>
        </tr>
      </thead>
      <tbody v-if="ScreenTypes.length > 0">
        <tr v-for="(item, key) in ScreenTypes" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  item.screen_type_is_active === 'Y' ? 'active' : 'inactive'
                "
              />
              <span
                v-if="$can('update', 'Screen Type')"
                class="edit-icon ml-4 blue-icon"
                @click="goToRoute('/cinema-manager/edit-screen-type', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </span>
            </div>
          </td>

          <td>{{ $tc(item.screen_type_name, 1) }}</td>
        </tr>
      </tbody>
      <tbody v-if="ScreenTypes.length == 0">
        <td>{{ errors.message }}</td>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      ScreenTypes: [],
      customErrors: {
        message: "",
      },
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      status: [
        { label: "Active", value: "Y" },
        { label: "Inactive", value: "N" },
        { label: "All", value: "" },
      ],
      selectedStatus: "Active",
      selectedStatusValue: "Y",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    this.getScreenTypesList();
    this.getviewingnumber();
  },
  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getScreenTypesList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event === "All") {
        // this.perPage = this.rows;
        // this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    onStatusChange(statusItem) {
      this.selectedStatus = statusItem.label;
      this.selectedStatusValue = statusItem.value;
      this.currentPage = 1;
      this.getScreenTypesList();
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getScreenTypesList();
      } else {
        this.currentPage = event;
        this.getScreenTypesList();
      }
    },
    /* eslint-disable */
    goToRoute: function (path, item) {
      console.log("item :", item);
      const { screen_type_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: screen_type_id,
        },
      });
    },

    getScreenTypesList: function () {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        screen_type_is_active: this.selectedStatusValue,
      };
      this.ScreenTypes = [];
      MasterService.GetScreenTypes(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.ScreenTypes = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                // if (this.selectedvalue === "All") {
                //   this.perPage = data.totalRows;
                // }
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(data.error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScreenTypeComponent/screenType.vue